/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiJobPreemptRequest
 */
export interface ApiJobPreemptRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiJobPreemptRequest
     */
    jobIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiJobPreemptRequest
     */
    jobSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiJobPreemptRequest
     */
    queue?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiJobPreemptRequest
     */
    reason?: string;
}

export function ApiJobPreemptRequestFromJSON(json: any): ApiJobPreemptRequest {
    return ApiJobPreemptRequestFromJSONTyped(json, false);
}

export function ApiJobPreemptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiJobPreemptRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobIds': !exists(json, 'jobIds') ? undefined : json['jobIds'],
        'jobSetId': !exists(json, 'jobSetId') ? undefined : json['jobSetId'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function ApiJobPreemptRequestToJSON(value?: ApiJobPreemptRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jobIds': value.jobIds,
        'jobSetId': value.jobSetId,
        'queue': value.queue,
        'reason': value.reason,
    };
}

